/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  REGISTRY_MATERIAL_RESOURCE_NPA,
  REGISTRY_MATERIAL_RESOURCE_NPA_URL,
} from 'SharedDir/backend/endpoints/registry-material-resource';
import { NpaAttachBackendType, NpaAttachType } from 'SharedDir/constants/tmc-registry';
import { AttachmentsBare } from 'SharedDir/declarations/departments';
import { RegistryMaterialResource } from 'SharedDir/declarations/registry-material-resource';
import { FileBare } from 'SharedDir/declarations/shared';
import { TtpHistory } from 'SharedDir/declarations/ttp-history';

export default class TmcRegistryNpaApiClass extends SimpleApi<
  RegistryMaterialResource.NpaFull,
  RegistryMaterialResource.NpaCreate,
  RegistryMaterialResource.NpaUpdate,
  RegistryMaterialResource.NpaBare
> {
  constructor() {
    super(REGISTRY_MATERIAL_RESOURCE_NPA_URL);
  }

  protected readonly endpoints = REGISTRY_MATERIAL_RESOURCE_NPA;

  public async getHistory(id: number, params: any) {
    const endpoint = this.endpoints.HISTORY(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  public async getHistoryAct(id: number, params: any) {
    const endpoint = this.endpoints.HISTORY_ACT(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  async approve(npaId: string | number) {
    const url = `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${npaId}`;
    const { data: responseData } = await http({ url, method: 'post' });
    return responseData;
  }

  async addMaterialResourceRecord(
    type: NpaAttachBackendType,
    npaId: string | number,
    data: RegistryMaterialResource.RegistryNpaCreate
  ) {
    const url = `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${npaId}/${type}`;
    const { data: responseData } = await http({ url, method: 'post', data });
    return responseData;
  }

  async updateMaterialResourceRecord(
    type: NpaAttachBackendType,
    npaId: string | number,
    id: string | number,
    data: RegistryMaterialResource.RegistryNpaCreate
  ) {
    const url = `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${npaId}/${type}/${id}`;
    const { data: responseData } = await http({ url, method: 'put', data });
    return responseData;
  }

  async removeMaterialResourceRecord(
    type: NpaAttachBackendType,
    npaId: string | number,
    id: string | number
  ) {
    const url = `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${npaId}/${type}/${id}`;
    const { data } = (await http({
      url,
      method: 'delete',
    })) as AxiosResponse<RegistryMaterialResource.NpaFull>;
    return data;
  }

  async generateAct(id: number | string, userCertificateId: number | null = null) {
    const { data } = (await http({
      ...REGISTRY_MATERIAL_RESOURCE_NPA.GENERATE_ACT(id),
      params: userCertificateId != null ? { userCertificateId } : undefined,
    })) as AxiosResponse<AttachmentsBare>;

    return data;
  }

  async retryEgisso(registryMaterialResourceNpaId: number) {
    const { data } = (await http(
      REGISTRY_MATERIAL_RESOURCE_NPA.RETRY_EGISSO(registryMaterialResourceNpaId)
    )) as AxiosResponse<RegistryMaterialResource.NpaFull>;

    return data;
  }
}
